import { render } from "./Pagopersonalmodal.vue?vue&type=template&id=f95e7bc2&scoped=true"
import script from "./Pagopersonalmodal.vue?vue&type=script&lang=js"
export * from "./Pagopersonalmodal.vue?vue&type=script&lang=js"

import "./Pagopersonalmodal.vue?vue&type=style&index=0&id=f95e7bc2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95e7bc2"]])

export default __exports__